import React, { Component, Fragment } from 'react';
import LandingHeader from '../components/landing/LandingHeader';
import LandingFooter from '../components/landing/LandingFooter';
import GetStarted from '../components/landing/GetStarted';
import Heading from '../components/global/Heading';
import ContentSection from '../components/landing/ContentSection';
import { Link } from 'react-router-dom';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import '../static/SecondaryPages.css';

const localeMessages = defineMessages({
	terms_title: {
		id: 'terms.title',
		defaultMessage: `Terms and Conditions`,
	},
	terms_privacy_policy: {
		id: 'terms.privacy_policy',
		defaultMessage: `Privacy Policy`,
	},
	terms_privacy_policy_here: {
		id: 'terms.privacy_policy_link_text',
		defaultMessage: `here`,
	},
});

const Title = props => (
	<Fragment>
		<h1 className='mb-10 mt-20'>{props.children}</h1>
	</Fragment>
);

const Par = props => (
	<p className='mb-10'>{props.children}</p>
);

class Terms extends Component {

	componentDidMount() {
		window.$("body").animate({ scrollTop: 0 }, 0);
	}
	
	render() {
		return (
			<Fragment>
				<LandingHeader history={this.props.history} disableAutoRoute={true} />
				<Heading title={this.props.intl.formatMessage(localeMessages.terms_title)} />

				<ContentSection noAnimate={true} addedSectionClass="pilotly-tos p-0 t-a-c-padding">
					<div className="tos-content-container">
						<Par>
							<FormattedMessage
								id="terms.agree_to_use_site"
								defaultMessage={`Welcome to Pilot.ly (Pilotly.com) (this "Site"). By using this Site, registering as a member of Pilotly, participating in the Pilotly Points membership program ("Points" or "Pilotly Points") or participating in any survey or study provided or hosted by Pilotly (each, a "Survey" and collectively "Surveys"), you agree to these Terms of Use and Membership ("Terms"). If you do not agree, do not use this Site.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.reserves_right"
								defaultMessage={`Pilotly reserves the right, at its sole discretion, to change, modify, add or remove portions of these Terms, including our Privacy Policy, at any time. It is your responsibility to check these Terms periodically for changes.  We will do our best to notify you when changes are made to this agreement using the contact information you provide to our system. Your continued use of this Site following the posting of such changes will mean that you accept and agree to the changes. Provided you comply with these Terms, Pilotly grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use this Site.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.eligibility_title"
								defaultMessage={`Eligibility`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.panel_membership"
								defaultMessage={`Membership in any Pilotly panel is free and is open to individuals only (not corporations or other business entities) that are at least 13 years of age or such other age as required by your geographic location. Membership in certain panels may be further restricted based on demographic attributes, such as, your age or geographic location. If you are less than eighteen (18) years of age and win any prize or receive any cash award through Pilotly Points or other Pilotly incentive program, then such award will be made to your legal guardian. You are permitted to have only one account.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.registration_title"
								defaultMessage={`Registration and Passwords`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.valid_user_information"
								defaultMessage={`In order to gain access to the Site, you will need a membership account to be established in your name and any Points properly credited to your account, you must complete the provided online registration form. To open a member account, you must provide Pilotly with complete and valid contact information, including your full legal name, valid e-mail address, and all other requested information. Your account must have a unique and valid e-mail address and password.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.registration_information"
								defaultMessage={`You agree to provide only accurate, current and complete registration information and to keep that information updated in order to maintain its accuracy. Pilotly may terminate or suspend your membership and you may forfeit your Points if you fail to provide or keep your personal information accurate and complete.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.password_security"
								defaultMessage={`You may use only one (1) password to open and access your account, and you may not use another account holder's password or allow anyone else to use your password, for any reason. You are solely responsible for the security of your user name and password and any activity that occurs under your membership account, whether authorized or unauthorized. Pilotly will not be responsible for any losses incurred through the use of your password by a third party, except when unauthorized use is directly attributable to the gross negligence or fraud of Pilotly. You agree to immediately notify Pilotly of any unauthorized use or breach of your member account.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.password_reset"
								defaultMessage={`Should you forget your password, you may use our password reset process by which you can request an e-mail to reset your password so that you can regain use of your account. This procedure assumes that the e-mail address provided by you when registering is used (or the new one provided in the event of an update).`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.invitations"
								defaultMessage={`By joining as a member of Pilotly's panels, you agree to receive invitations to participate in Pilotly's Surveys and its third-party partners via e-mail. Pilotly does not guarantee that you will receive a certain minimum volume of invitations or any invitations at all. Your participation in any Survey and your disclosure of any personally-identifiable information is completely voluntary.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.relationship_title"
								defaultMessage={`Relationship`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.equipment_and_compensation"
								defaultMessage={`You are responsible for providing any computer equipment and communications services necessary to connect to and access this Site. You agree that neither your membership in a Pilotly panel nor your completion of any Surveys for Pilotly and its clients create any agency, partnership or employment relationship, and that your completion of Surveys is strictly as an independent contractor. You also agree the Points or other incentives you receive for completing Surveys are the only compensation you will receive for your completion of Surveys.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.code_of_conduct_title"
								defaultMessage={`Member Code of Conduct:`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.piotly_community"
								defaultMessage={`Pilotly is an online community dedicated to making your voice heard and allowing you to tell leading providers of products and services what you think. When you use and post content to the Pilotly Site or our community we ask that you observe the following rules:`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.safe_environment"
									defaultMessage={`Be courteous and respect the opinions of others and behave in a manner that supports a safe and comfortable environment for all members.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.do_not_post"
									defaultMessage={`Do not post any of the following:`}
								/>
								<ul className="pilotly-tos-list pilotly-tos-sublist">
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.advocacy"
											defaultMessage={`Material that advocates illegal activity or political, religious or ideological beliefs.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.personal_attacks"
											defaultMessage={`Personal attacks or anything (including "jokes" that may be misconstrued) obscene, vulgar, illegal, harmful, insulting, threatening, abusive, harassing, defamatory, libelous, untrue, misleading or invasive of someone else's privacy.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.advertising_solicitations"
											defaultMessage={`Advertising and solicitations - Do not use any community areas to buy or solicit for goods, services, or money, or to advertise or sell products or services to others. For example, do not post any advertising, referrals, promotional materials, junk mail, "spam", chain letters, pyramid schemes or any other form of solicitation.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.copyrighted"
											defaultMessage={`Any content that infringes any patent, copyright, trademark, trade secret or other intellectual property right of another.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.for_pilotly"
											defaultMessage={`Any statement that expresses or implies that any actions you take are endorsed by Pilotly or our clients.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.invalid_responses"
											defaultMessage={`Do not take any Survey other than in good faith, such as providing false answers or speeding through a survey or answering each question the same way. Pilotly reserves the right to withhold awarding Points to you if, in Pilotly's reasonable view, your Survey responses are untruthful or not well considered.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.personal_use"
											defaultMessage={`Do not access or use any part of the Site for anything other than your personal, non-commercial use.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.invalid_access"
											defaultMessage={`Do not access or use any part of the Site in any way that may violate any applicable provincial, federal, or international law, regulation, or other governmental requirement and/or regulation, treaty or tariff.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.do_not_sell"
											defaultMessage={`Do not resell, barter, trade or otherwise attempt to generate income by providing access to your Pilotly Points to others.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.no_impersonation"
											defaultMessage={`Do not impersonate any individual or entity, including, without limitation, a Pilotly employee, agent or client, or other Pilotly members or otherwise misrepresent your affiliation with any person or entity, including by "framing" any portion of this Site to make it look like you have a relationship with us or that we have endorsed you for any purpose.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.circumvent_points"
											defaultMessage={`Do not attempt to circumvent the Points system Pilotly, including by requesting rankings from other members or posting content which does not respond to or pose any question in order to garner points.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.to_media"
											defaultMessage={`Do not publish or make reference in any media to any Survey or Site content without our prior written permission.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.collect_information"
											defaultMessage={`Do not collect or store any personal information about other members.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.unauthorized_access"
											defaultMessage={`Do not attempt to access any service or area of the Site that you are not authorized to access.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.data_extract"
											defaultMessage={`Do not use any robot, spider, scraper or other automated means or interface not provided by us to access the Site or extract data.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.malware"
											defaultMessage={`Do not send to or otherwise impact us or this Site (or anything or anyone else) with harmful, illegal, deceptive or disruptive code such as a virus, "spyware", "adware" or other code that could adversely impact this Site or any recipient or take any action, such as a denial of service attack, that might impose a significant burden on this Site's infrastructure or interfere with the ordinary operation of this Site.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.pilotly_help"
											defaultMessage={`Do not re-post on the Site any statements you receive from the Pilotly help desk.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.abusive_communication"
											defaultMessage={`Do not communicate with the Pilotly help desk in a manner which is obscene, vulgar, harmful, insulting, threatening, abusive, harassing, defamatory, libelous, untrue or misleading.`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="terms.do_not_post.abusive_activity"
											defaultMessage={`Do not engage in any other activity that the Company reasonably deems improper or abusive.`}
										/>
									</li>
								</ul>
							</li>
						</ul>

						<Par>
							<FormattedMessage
								id="terms.conduct_failure_to_comply"
								defaultMessage={`Failure to comply with this Code of Conduct may result in termination of your membership account and forfeiture of any Pilotly Points you have accrued.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.confidentiality_of_surveys_title"
								defaultMessage={`Confidentiality of Surveys`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.confidential_information"
								defaultMessage={`Pilotly's clients may disclose confidential and/or proprietary information and materials to you as part of Surveys, and such information and materials shall remain the sole and exclusive property of its owner. This confidential information may include, but is not limited to, new product ideas or concepts, packaging concepts, advertising and movie or television concepts or trailers, and the text, visual images and sounds related thereto. By becoming a member, you agree that you will keep the contents and materials disclosed to you as part of all Surveys in which you participate confidential and not disclose them to any third party or use the confidential information for any purpose except for the sole purpose of completing the Survey. If you breach this obligation, in addition to forfeiture of your Points and termination of your account, you may be liable for monetary damages to Pilotly and/or our client for damages caused by the result of your breach.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.privacy_policy_title"
								defaultMessage={`Privacy Policy`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.personal_information"
								defaultMessage={`To better understand how Pilotly collects, uses and shares your personal information, please review our privacy policy, which is available {terms_privacy_policy_link}.`}
								values={{ terms_privacy_policy_link: <a href="/privacy-policy">{this.props.intl.formatMessage(localeMessages.terms_privacy_policy_here)}</a> }}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.pilotly_points_title"
								defaultMessage={`Pilotly Points`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.what_are_points"
								defaultMessage={`What are Points?`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.point_incentives"
								defaultMessage={`Pilotly values our members' opinions, and to show our appreciation, Pilotly offers incentives in the form of credits called “Points,” which are credited to your account maintained by Pilotly. Points are redeemable for cash, prizes or entries into sweepstakes as specified and subject to the terms below.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.earning_points"
								defaultMessage={`Earning Points`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_credited"
								defaultMessage={`Points will be credited to your account only through your participation in activities authorized by Pilotly, which include, but are not limited to, registration as a panelist, completion of demographic profiles and completion of qualitative or quantitative marketing research activities performed by Pilotly, and only in accordance with the specific incentive offer disclosed for each activity. Specifically, you may earn points as follows:`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.survey_completion_points"
									defaultMessage={`Survey Completion: Earn Points for each survey you qualify for and complete. Points awarded vary by survey.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.member_profile_points"
									defaultMessage={`Personal Interest Survey (Profile) Completion: Panelists can earn additional Points by completing the member profiles.`}
								/>
							</li>
						</ul>

						<Par>
							<FormattedMessage
								id="terms.when_credits_applied"
								defaultMessage={`The timing of credits for points depends on the Survey. In general, you can only redeem points after you have earned more than 60 Pilotly Points. For some Surveys, credits are applied very quickly or within a few days; for others, the credits are applied after the Survey has closed.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_claims"
								defaultMessage={`Pilotly will maintain a record of the Points credited to and debited from your account and allow you to check the status of your account online by logging in and checking the "Your Points" tab. Although Pilotly makes every effort to ensure that accounts are credited correctly, it is your responsibility to verify that your Points have been credited properly. If you feel the incentive amounts credited to your account are incorrect, you must contact Pilotly by email within 30 days following our alleged error and explain in full the basis of your dispute, attaching any relevant information which offers evidence of the discrepancy. Upon receipt of your notice, we will investigate your claim and notify you of our decision to adjust or maintain the amount of Points credited to your account, as we deem appropriate, within thirty (30) days. If we need additional time to decide your claim, we will notify you and will endeavor to render a decision as soon as reasonably practicable. Any decision by us with regard to such a claim will be final.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.redeeming_points"
								defaultMessage={`Redeeming Points`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.rewards_center"
								defaultMessage={`Once you have a balance of over 60 Pilotly Points, you can spend your Points by going to the “Rewards Center” located under the “Rewards” tab in your Pilotly profile home page. Points are awarded for survey completion, personal profile surveys, and other participation on this Site. Points can be redeemed for gift cards. In our current model, 10 points is equivalent to $1.00.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.payment_delivery"
								defaultMessage={`All payments, including electronic gift cards or vouchers and PayPal payments will be delivered within 6 weeks of your request. Pilotly will e-mail gift card information to the provided email. Please make sure that we have your email address to avoid any delays in delivery or invalid redemptions. Additionally, checks are valid for one (1) year, and members must report a missing payment within one (1) year from the request date in order to for Pilotly to re-issue payment.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.paypal_payments"
								defaultMessage={`PayPal payments will be sent to the account you provide in the PayPal Details page within your Account. Be sure to keep this updated to ensure delivery. For electronic gift cards and vouchers, please view the reward details in the Rewards Center for each reward for specific details on standard delivery methods and timelines. All rewards are void where prohibited by applicable laws or regulations and are subject to change as may be necessary to comply with such laws or regulations.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.expiration_of_points"
								defaultMessage={`Expiration of Points`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_validity"
								defaultMessage={`When Points are credited to your account they will remain valid for one year (12 months) from the date they are earned. If after this period the Points have not been used, they will automatically expire and be deleted from your account. This deduction will always occur towards the end of the month, usually on the 28th day. For example, if you earned Points on 15 March 2020, they will be removed from your account on 28 March 2021, if they are still in your account. Points cannot be redeemed after the expiration date.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_account_canceled"
								defaultMessage={`In addition, all of your Points will immediately expire and be forfeited in the event that you cancel your account at Pilotly or if your account becomes "inactive." To be an active member means that you have joined Pilotly and participated in a Survey or other activity on this Site within 12 months from your initial registration or within the preceding 12 months. Pilotly will not provide you with any notice of the cancellation and forfeiture of any of your Points. Pilotly reserves the right to suspend these cancellation and forfeiture rules in its sole discretion.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.misconduct_fraud"
								defaultMessage={`Misconduct, Fraud and Correcting Account Errors`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_activity"
								defaultMessage={`Pilotly retains the right to monitor all member activity within Pilotly Points. If required by law, if you have violated our Code of Conduct above, or in the event that your account shows signs of fraud, abuse or suspicious activity, your member account may be terminated and you may forfeit all accumulated Points. If you have conducted any fraudulent activity, Pilotly reserves the right to take any necessary legal action and may have grounds to confiscate any rewards redeemed as a result of such activity. In addition, you may be liable for monetary losses to Pilotly, including litigation costs and damages, and you will not be allowed to participate in Pilotly Points in the future.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_balance"
								defaultMessage={`If your account does not accurately reflect your Point balance, Pilotly reserves the right to correct such errors. If you have been awarded Points in error or you believe that your member account has been the subject of suspicious activity, please contact Pilotly immediately. If it is determined that you have been the victim of fraud, the Points you have earned will be transferred to a new member account.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.transferability"
								defaultMessage={`Transferability`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_value"
								defaultMessage={`Points have no cash value, and may not be assigned, transferred and/or pledged to any third party. You have no property rights or other legal interests in any rewards Points granted pursuant to the Program.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.program_duration"
								defaultMessage={`Program Duration & Changes to Rules`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.points_redemption"
								defaultMessage={`Any revisions may affect your ability to use any Points you accumulate. If the Program is terminated or your membership is terminated by Pilotly other than as a result of your breach of these Terms, you will only have 30 days from such termination date to redeem all of your accumulated Points. If there is a modification to Pilotly Points, we will endeavor to notify you; however, Pilotly will not be responsible if you do not learn of the modification. The rewards offered and point levels required for specific rewards are subject to change without notice. All rewards are subject to availability.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.intellectual_property_title"
								defaultMessage={`Pilotly Intellectual Property`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.intellectual_property_laws"
								defaultMessage={`This Site is protected by intellectual property laws and you agree to respect them. All rights not expressly granted to you are reserved by Pilotly or its licensors.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.logo_trademarks"
								defaultMessage={`The logo and trademarks "PILOT.LY", "PILOTLY.com" are trademarks or registered trademarks of Pilotly or its affiliates. All other trademarks, service marks, logos and trade names used on this Site are the property of Pilotly or their respective owners. All rights are reserved.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.content_definition"
								defaultMessage={`As used herein, "Content" means (without limitation) all text, design, graphics, images, sound files, animation, video, interfaces, software, code and the selection and arrangement thereof appearing or included from time to time on this Site. All Content on this Site is subject to intellectual property rights, contractual or other protection. The intellectual property rights are owned by us or our licensors. No Content may be copied, distributed, republished, uploaded, posted or transmitted in any way except pursuant to the express provisions of these Terms or with our prior non-electronic consent. Modification or use of the materials for any other purpose may violate intellectual property rights. No title to copies or to intellectual property rights are transferred to users - all title and rights remain with us. This Site is © PILOTLY. All rights reserved.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.warranties_title"
								defaultMessage={`Disclaimer of Warranties`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.pilotly_points"
								defaultMessage={`By utilizing the Pilotly Points program, you acknowledge and agree that Pilotly is not a bank or any other kind or form of financial institution and that "Points" credited to your account are not actual cash deposits, do not earn interest, and are only account entries that entitle you to the amount of the credited Points if you redeem them in accordance with these terms of use. You further agree that you may only redeem the amounts in your account in the manner and according to the procedures described in these terms of use, which we may amend from time to time. Pilotly is not responsible for the actions of any third party, such as the issuers of any gift cards, vouchers or other rewards redeemable for Points.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.sole_risk_as_is"
								defaultMessage={`You expressly agree that your use of this Site and the Pilotly Points program is at your sole risk. You agree that this Site, all information on this Site, the services offered by this and their functionality, and the Pilotly Points program are provided by Pilotly or its corporate parents or affiliates, successors or assigns, suppliers or agents, "AS IS" and "AS AVAILABLE." Pilotly is not responsible for typographical errors regardless of source. In addition, Pilotly does not represent or warrant that the information accessible on this Site is accurate, complete, or current. You hereby release Pilotly and its affiliates and third party providers from all liability regarding the redemption and use of any rewards, including any rewards that, after receipt, may be lost, stolen or destroyed.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.warrenties_disclaimer"
								defaultMessage={`PILOTLY DISCLAIMS ALL WARRANTIES, CONDITIONS AND DUTIES, EXPRESS, IMPLIED OR STATUTORY, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTIES, DUTIES OR CONDITIONS: (a) OF MERCHANTABILITY, OF FITNESS FOR A PARTICULAR PURPOSE OR USE, OF RESULTS, AND OF ACCURACY OR COMPLETENESS OR PRIVACY OR SECURITY OF INFORMATION; AND (b) CREATED BY TRADE USAGE, COURSE OF DEALING OR COURSE OF PERFORMANCE.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.duties_disclaimer"
								defaultMessage={`PILOTLY FURTHER DISCLAIMS ALL DUTIES TO YOU, IF ANY SUCH DUTIES EXIST, INCLUDING BUT NOT LIMITED TO REASONABLE CARE, WORKMANLIKE EFFORT, FREEDOM FROM COMPUTER VIRUS, AND LACK OF NEGLIGENCE. PILOTLY FURTHER MAKES NO WARRANTY OF TITLE OR AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF ANY ASPECT OF THE COMPLETE SITE, OR AGAINST INFRINGEMENT.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.liability_title"
								defaultMessage={`Limitation of Liability`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.pilotly_affiliate_liability"
								defaultMessage={`TO THE FULLEST EXTENT ALLOWED BY LAW, YOU AGREE THAT NEITHER PILOTLY NOR ANY OF OUR AFFILIATES OR AGENTS WILL BE LIABLE TO YOU AND/OR ANY OTHER PERSON FOR ANY SPECIAL, INCIDENTAL, PUNITIVE, CONSEQUENTIAL OR SIMILAR GENERAL DAMAGES, OR FOR DAMAGES FOR LOST PROFITS, LOSS OR IMPAIRMENT OF PRIVACY, SECURITY Of DATA, FAILURE TO MEET ANY DUTY (INCLUDING BUT NOT LIMITED TO ANY DUTY OF GOOD FAITH, WORKMANLIKE EFFORT OR OF LACK OF NEGLIGENCE), OR FOR ANY OTHER SIMILAR DAMAGES WHATSOEVER THAT ARISE OUT OF OR ARE RELATED TO ANY BREACH OR OTHER ASPECT OF THE ENTIRE AGREEMENT OR THIS SITE, EVEN IF PILOTLY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IN THE EVENT OF FAULT, TORT (INCLUDING NEGLIGENCE) OR STRICT OR PRODUCT LIABILITY OR MISREPRESENTATION.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.fair_market_value"
								defaultMessage={`IN NO EVENT SHALL THE LIABILITY OF PILOTLY, ITS CORPORATE PARENTS OR AFFILIATES, SUCCESSORS OR ASSIGNS, SUPPLIERS OR AGENTS EXCEED THE ACTUAL RETAIL VALUE OF AN APPLICABLE REWARD AT ISSUE, OR IF A DISPUTE RELATES GENERALLY TO YOUR USE OF THE PROGRAM, TO THE FAIR MARKET RETAIL VALUE OF THE REWARDS WHICH YOUR UNUSED, UNEXPIRED, NON-CANCELED POINTS ARE CONVERTIBLE INTO.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.indemnification_title"
								defaultMessage={`Indemnification`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.agree_to_indemnify"
								defaultMessage={`You agree to indemnify and hold Pilotly, and its parent and affiliated companies, together with their officers, directors, owners, employees and agents harmless from any and all claims, losses, damages, suits, fines, levy's and costs (including reasonable attorney's fees and expert witness costs, including costs associated with in-house counsel), (collectively "Claims"), arising from or related to your use of this Site and any content you place on this Site, including Claims made by third parties. You agree that Pilotly has the unlimited right to defend any Claim and to settle any Claim without your prior permission. You agree to provide Pilotly with all reasonable assistance in the defense of any Claim.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.canceling_account_title"
								defaultMessage={`Cancelling Your Account`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.cancel_account"
								defaultMessage={`You may cancel your account at any time by contacting Pilotly at {contact_pilotly_link} or by going to “Account” underneath your profile picture and selecting "Unsubscribe Options" on the bottom left hand corner, then completing the process by selecting the option “cancel your account”. Your account will also be cancelled if you withdraw from the Pilotly panel. Immediately upon deletion or your withdrawal from the Pilotly panel, your account will be closed. You understand and agree that, as noted above, upon closing your account, your right to access the Pilotly Points program will cease and all Points credited to your account at such time, however and whenever accumulated, will be forfeited. Pilotly may terminate your account at any time for any reason.`}
								values={{ contact_pilotly_link: <a href='mailto:inquiry@pilot.ly'>inquiry@pilot.ly</a> }}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.tax_liability_title"
								defaultMessage={`Tax Liability`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.local_laws"
								defaultMessage={`You may be required under local laws to pay taxes on prizes you receive. You acknowledge that we may supply information to taxing agencies, or withhold taxes, at the request of those agencies or as we, in our sole discretion, deem appropriate. You acknowledge and agree that you will provide Pilotly with any additional personal information that Pilotly needs to comply with any reporting or withholding obligations. Your failure to provide such information within 30 days of a request sent by Pilotly to the email address registered at that time may result in the forfeiture of Points or the prizes you may have won.`}
							/>
						</Par>

						<Title>
							Links
							<FormattedMessage
								id="terms.registration_title"
								defaultMessage={`Registration and Passwords`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.third_party_links"
								defaultMessage={`Pilotly may provide links to third-party websites as a convenience to you, and Pilotly's providing of any link does not constitute an endorsement by such site of Pilotly or vice versa. You agree that Pilotly is not responsible for examining or evaluating the content or accuracy and Pilotly does not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third parties. You agree that you will not use any third-party materials in a manner that would infringe or violate the rights of any other party and that Pilotly is not in any way responsible for any such use by you.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.notices_title"
								defaultMessage={`Notices`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.notices_to_you"
								defaultMessage={`Notices to You: We may give you all notices that we are required to give by posting notice on this Site. You also agree that we may give notice by email in our discretion, including notice of subpoenas or other legal process (if any). We may provide notice to any email or other address that you provide during registration. You agree to keep your address current and to check for notices posted on the Site.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.notices_to_us"
								defaultMessage={`Notices to Us: These can be sent via email to {contact_pilotly_link}, with a subject of Terms of Use Inquiry.  Any email sent with regards to Terms of Use without that subject line may not be responded to in timely manner.`}
								values={{ contact_pilotly_link: <a href='mailto:inquiry@pilot.ly'>inquiry@pilot.ly</a> }}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.miscellaneous_title"
								defaultMessage={`Entire Agreement; Miscellaneous.`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.entire_agreement"
								defaultMessage={`These Terms, including items incorporated into them (e.g., the {privacy_policy_link}), as well as any additional terms or conditions contained on the Site for particular activities, and disclosures provided by us and consents provided by you on the Site (collectively, the "Entire Agreement"), constitute the entire agreement between us and neither party has relied on any representations made by the other that are not expressly set forth in the Entire Agreement. If any provision of the Entire Agreement is found by a court of competent jurisdiction to be invalid, the remaining provisions will remain in full force and effect, provided that the allocation of risks described herein is given effect to the fullest extent possible. Our failure to act with respect to a breach does not waive our right to act with respect to subsequent or similar breaches, and time is of the essence of the Entire Agreement.`}
								values={{ privacy_policy_link: <Link to='/privacy-policy'>{this.props.intl.formatMessage(localeMessages.terms_privacy_policy)}</Link> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="terms.export_laws"
								defaultMessage={`This Site is controlled by us from our offices within the United States of America and is directed to U.S. users. If you choose to access this Site from locations outside the U.S., you do so at your own risk and you are responsible for compliance with applicable local laws. You may not use or export anything from the Site in violation of U.S. export laws and regulations or the Entire Agreement.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="terms.copyright_agent_title"
								defaultMessage={`Notice of Copyright Agent`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="terms.intellectual_property_rights"
								defaultMessage={`Pilotly respects the intellectual property rights of others and requests that you do the same. Anyone who believes that their work has been reproduced in this Site in a way constituting copyright infringement may provide a notice to the designated Copyright Agent for the Site containing the following:`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.authorized_signature"
									defaultMessage={`An electronic or physical signature of a person authorized to act on behalf of the owner of the copyright interest;`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.copyright_identification"
									defaultMessage={`Identification of the copyrighted work claimed to have been infringed;`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.material_identification"
									defaultMessage={`Identification of the material that is claimed to be infringing and information reasonably sufficient to permit us to locate the material;`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.contact_info"
									defaultMessage={`The address, telephone number, and, if available, an e-mail address at which the complaining party may be contacted;`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.unauthorized_use"
									defaultMessage={`A representation that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law;`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="terms.intellectual_property.authorized_complaint"
									defaultMessage={`A representation that the information in the notice is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.`}
								/>
							</li>
						</ul>

						<Par>
							<FormattedMessage
								id="terms.claims_and_notices"
								defaultMessage={`Copyright infringement claims and notices (but not other notices) should be sent to the attention of General Counsel in the following manner:`}
							/>
						</Par>

						<ul>
							<li className="pilotly-tos-listitem">
								<span>
									<FormattedMessage
										id="terms.by_mail"
										defaultMessage={`by mail:`}
									/>
								</span>
								Pilotly, 555 12th st 5th floor, Oakland CA 94607, USA
							</li>
							<li className="pilotly-tos-listitem">
								<span>
									<FormattedMessage
										id="terms.by_email"
										defaultMessage={`by email:`}
									/>
								</span>
								<a href="mailto:inquiry@pilot.ly">inquiry@pilot.ly</a>
							</li>
						</ul>
					</div>
				</ContentSection>

				<GetStarted />
				<LandingFooter />
			</Fragment>
		);
	}
}

export default injectIntl(Terms);



// WEBPACK FOOTER //
// ./src/pages/Terms.js